import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getSelfServiceLandingPageData } from "../../api/selfServiceServices";
import type { SelfServiceLandingPageDataResponse } from "../../api/types";
import { landingPageDataTanstackCacheKey } from "../../portal/containers/users/hooks/useAuthenticators";

export const useSelfServiceData = () => {
    const queryClient = useQueryClient();
    const cachedData = queryClient.getQueryData<SelfServiceLandingPageDataResponse>([landingPageDataTanstackCacheKey]);

    return useQuery({
        queryKey: [landingPageDataTanstackCacheKey],
        queryFn: getSelfServiceLandingPageData,
        enabled: !cachedData,
        initialData: cachedData,
        retry: false,
    });
}
